// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { checkoutReviewAndSubmitPaymentDetailsStyles } from "@steiner/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails";
import Edit from "@steiner/XDL/Icons/Edit";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

checkoutReviewAndSubmitPaymentDetailsStyles.fieldset = {
    css: css`
        margin: 0;
        padding: 0;
        border: 0;

        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto;
        gap: 17px 22px;

        ${xScreen("lte", "xs")} {
            grid-template-columns: auto;
        }
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.poNumberGridItem = {
    css: css`
        grid-area: 1 / 1 / 1 / 2;
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.jobGridItem = {
    css: css`
        grid-area: 1 / 2 / 1 / 3;
        ${xScreen("lte", "xs")} {
            grid-area: 2 / 1 / 3 / 2;
        }
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.styledHrGridItem = {
    css: css`
        grid-area: 2 / 1 / 3 / 3;
        ${xScreen("lte", "xs")} {
            grid-area: 3 / 1 / 4 / 2;
        }
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodAndPONumberContainer = {
    gap: 16,
    css: css`
        grid-area: 3 / 1 / 4 / 3;
        ${xScreen("lte", "xs")} {
            grid-area: 4 / 1 / 5 / 2;
        }
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.creditCardDetailsGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.creditCardAddressGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.creditCardTypeStyles = {
    container: {
        css: css`
            margin-top: 8px;
        `,
    },
};

checkoutReviewAndSubmitPaymentDetailsStyles.addNewPaymentContainer = {
    css: css`
        margin-top: 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.orText = {
    variant: "h6",
    css: css`
        margin-bottom: 0;
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.cancelGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.cancelButton = {
    variant: "tertiary",
};

checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.paymentProfileExpiredErrorWrapper = {
    css: css`
        align-items: flex-start;
        display: flex;
        width: 100%;
        gap: 16px;
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.paymentProfileExpiredErrorText = {
    size: 12,
    color: "danger",
};

checkoutReviewAndSubmitPaymentDetailsStyles.paymentProfileEditCardLink = {
    icon: {
        iconProps: {
            src: Edit,
            size: 12,
        },
    },
    typographyProps: {
        size: 12,
        css: css`
            white-space: nowrap;
        `,
    },
};
